import React, { useEffect, useState } from 'react'
import "../css/Cursor.css"
const Cursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    let mouseX = 0;
    let mouseY = 0;

    const handleMouseMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    };

    const updatePosition = () => {
      setPosition((prevPosition) => ({
        x: prevPosition.x + (mouseX - prevPosition.x) * 0.2,
        y: prevPosition.y + (mouseY - prevPosition.y) * 0.2,
      }));
      requestAnimationFrame(updatePosition);
    };

    const handleHover = (element, isHovering) => {
      element.addEventListener('mouseover', () => setIsHovered(true));
      element.addEventListener('mouseout', () => setIsHovered(false));
    };

    // Function to observe the DOM changes
    const observeDOM = () => {
      const elements = document.querySelectorAll('a, button, [role="button"]');
      elements.forEach((element) => handleHover(element));

      // MutationObserver to detect new nodes
      const observer = new MutationObserver(() => {
        const newElements = document.querySelectorAll('a, button, [role="button"], .products-card');
        newElements.forEach((element) => handleHover(element));
      });

      observer.observe(document.body, { childList: true, subtree: true });

      return observer;
    };

    // Start observing
    const observer = observeDOM();

    requestAnimationFrame(updatePosition);
    document.addEventListener('mousemove', handleMouseMove);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      observer.disconnect(); // Stop observing on cleanup
    };
  }, []);


  return (
    <div
      className={`cursor ${isHovered ? 'hovered' : ''}`}
      style={{ top: `${position.y}px`, left: `${position.x}px` }}
    />
  );
}

export default Cursor